<template>
  <div class="container">
    <span v-if="showTips">当前登录态异常，请重新登录{{platformName}}，然后再访问千川。即将前往{{platformName}}...</span>
  </div>
</template>

<script>
const APIS = {
  account_info: "/passport/web/account/info/?aid=1574&language=zh",
  check_login: "/check_login/",
  // logout: "/aff/logout",
  fxg_logout: "/index/dologout",
};

const SSO_HOST = "https://fxg-sso.jinritemai.com";
const SSO_HOST_BOE = "https://fxg-sso.bytedance.net";
const FXG_HOST = "https://fxg.jinritemai.com";
const FXG_HOST_BOE = "https://fxg-boe.bytedance.net";
const BUYIN_HOST = "https://buyin.jinritemai.com";
const BUYIN_HOST_BOE = "http://buyin-boe.bytedance.net";
const PASSPORT_CSRF_TOKEN = "passport_csrf_token";

function jsonp(url) {
  const script = document.createElement('script');
  script.src = url;
  script.type = 'application/json';
  document.body.appendChild(script);
}

function getCookie(name) {
  if (document.cookie.length > 0) {
    let cStart = document.cookie.indexOf(`${name}=`);
    if (cStart !== -1) {
      cStart = cStart + name.length + 1;
      let cEnd = document.cookie.indexOf(";", cStart);
      if (cEnd === -1) {
        cEnd = document.cookie.length;
      }
      return decodeURIComponent(document.cookie.substring(cStart, cEnd));
    }
  }
  return "";
}

const isBoe = () => window.location.origin.includes(".bytedance.net");
export default {
  data: () => ({
    showTips: false,
    endtime: 5,
    timer: 0,
    loginOut: "",
  }),
  computed: {
    platformName() {
      switch (this.platform) {
        case "fxg":
          return "抖店";
        case "buyin":
          return "百应";
        default:
          return "";
      }
    },
    getLonoutUrl() {
      if (isBoe()) {
        switch (this.platform) {
          case "fxg":
            return FXG_HOST_BOE + "/index/dologout/";
          case "buyin":
            return BUYIN_HOST_BOE;
          default:
            return "";
        }
      } else {
        switch (this.platform) {
          case "fxg":
            return FXG_HOST + "/index/dologout/";
          case "buyin":
            return BUYIN_HOST;
          default:
            return "";
        }
      }
    },
    getLoginUrl() {
      if (isBoe()) {
        switch (this.platform) {
          case "fxg":
            return FXG_HOST_BOE + "/login";
          case "buyin":
            return BUYIN_HOST_BOE;
          default:
            return "";
        }
      } else {
        switch (this.platform) {
          case "fxg":
            return FXG_HOST + "/login";
          case "buyin":
            return BUYIN_HOST;
          default:
            return "";
        }
      }
    },
  },
  methods: {
    async getCheckLoginUrl(service) {
      const ssoHost = isBoe() ? SSO_HOST_BOE : SSO_HOST;
      const res =
        (await this.$axios.get(`${ssoHost}${APIS.check_login}?service=${encodeURIComponent(service)}&aid=4272`, {
          service,
        })) || {};
      return res?.data?.redirect_url;
    },
    async checkLogin() {
      const loginHerf = await this.getCheckLoginUrl(this.$route.query.service);
      if (loginHerf) {
        window.location.replace(loginHerf);
      } else {
        if(window.Slardar) {
          window.Slardar('Sentry', (Sentry) => {
            Sentry.captureException(`获取sso登录态失败 APPINFO: `)
          })
        }
        this.showTips = true
        const ssoHost = isBoe() ? SSO_HOST_BOE : SSO_HOST;
        this.$axios.post(
          `${ssoHost}/aff/logout/?subject_aid=4966&aid=4272&service=${encodeURIComponent(FXG_HOST_BOE)}`,
          {
            account_sdk_source: "sso",
            subject_aid: 4966,
            aid: 4272,
            service: this.getLoginUrl,
            language: "zh",
          },
          {
            headers: {
              "x-tt-passport-csrf-token":
                getCookie(PASSPORT_CSRF_TOKEN) ||
                getCookie(`${PASSPORT_CSRF_TOKEN}_default`),
              "X-Requested-With": "XMLHttpRequest",
              "content-type": "application/x-www-form-urlencoded",
            },
          }
        )
        jsonp(this.getLonoutUrl)
        setTimeout(() => window.location.replace(this.getLoginUrl), 2000)
      }
    },
  },
  created() {
    if (this.$route.path.includes("fxg")) {
      this.platform = "fxg";
    }
    if (this.$route.path.includes("buyin")) {
      this.platform = "buyin";
    }
    this.checkLogin();
  },
};
</script>
<style lang="less">
.container {
  margin-top: 60px;
}
</style>